import { BaseProps } from '../../common/BaseProps';
import styles from './BotaoServico.module.css';

interface Props extends BaseProps {
  iconClass?: string;
  img?: string;
  text: string;
  disabled?: boolean;
  highlight?: string;
  badgeCount?: number;
};

const BotaoServico: React.FC<Props> = (props) => {
  const { onClick, iconClass, img, text, disabled, highlight, badgeCount } = props;

  return (
    <div
      className={`${styles.container} ${disabled ? styles.buttonDisabled : ''}`}
      onClick={onClick}
    >
      <div
        className={`${styles.iconWrapper} ${disabled ? styles.iconWrapperDisabled : ''} ${
          highlight === 'red' ? styles.redHighlight : ''
        }`}
      >
        {iconClass && <i className={`fa ${iconClass} ${styles.icon}`} />}
        {img && <img className={`${styles.img}`} src={img} alt="Ícone botão de serviço" />}
        {!!badgeCount && badgeCount > 0 && (
          <div className={styles.badge}>{badgeCount}</div>
        )}
      </div>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default BotaoServico;
